import { render, staticRenderFns } from "./UmaoiTable.vue?vue&type=template&id=dcddefaa&scoped=true&"
import script from "./UmaoiTable.vue?vue&type=script&lang=js&"
export * from "./UmaoiTable.vue?vue&type=script&lang=js&"
import style0 from "./UmaoiTable.vue?vue&type=style&index=0&id=dcddefaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcddefaa",
  null
  
)

export default component.exports